import React from "react";
import { Checkbox, Input } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { setOfficeNetworkFeedback } from "../../../redux/actions/feedbackActions";
import { setOfficeNetworkComments, setSelectedOptions } from "../../../redux/actions/officeNetworkAction";
import "./officenetwork.css";

const translations = {
  English: {
    title: "Office Network Connectivity",
    question: "Kindly select one or more of the following options for which you would like to provide a rating:",
    options: [
      "Performance of wired connections",
      "Performance of wireless connections",
      "Feedback on VPN Usage",
      "Proposals for enhancements",
    ],
    feedbackPrompt: "Do you have any suggestions/feedback for the team? (optional)",
    feedbackPlaceholder: "Comments",
  },
  Japanese: {
    title: "オフィスネットワーク接続",
    question: "評価を提供したい以下のオプションを1つ以上選択してください:",
    options: [
      "有線接続のパフォーマンス",
      "無線接続のパフォーマンス",
      "VPN使用状況のフィードバック",
      "改善提案",
    ],
    feedbackPrompt: "チームへの提案やフィードバックはありますか?（任意）",
    feedbackPlaceholder: "コメント",
  },
  Chinese: {
    title: "办公室网络连接",
    question: "请选择以下一个或多个选项，为其提供评分:",
    options: [
      "有线连接性能",
      "无线连接性能",
      "VPN使用反馈",
      "改进建议",
    ],
    feedbackPrompt: "您对团队有什么建议/反馈吗？（可选）",
    feedbackPlaceholder: "评论",
  },
  Dutch: {
    title: "Kantoornetwerkverbinding",
    question: "Selecteer een of meer van de volgende opties waarvoor u een beoordeling wilt geven:",
    options: [
      "Prestaties van bekabelde verbindingen",
      "Prestaties van draadloze verbindingen",
      "Feedback over VPN-gebruik",
      "Voorstellen voor verbeteringen",
    ],
    feedbackPrompt: "Heeft u suggesties/feedback voor het team? (optioneel)",
    feedbackPlaceholder: "Opmerkingen",
  },
  German: {
    title: "Büro-Netzwerkverbindung",
    question: "Wählen Sie eine oder mehrere der folgenden Optionen aus, für die Sie eine Bewertung abgeben möchten:",
    options: [
      "Leistung von kabelgebundenen Verbindungen",
      "Leistung von drahtlosen Verbindungen",
      "Feedback zur VPN-Nutzung",
      "Vorschläge für Verbesserungen",
    ],
    feedbackPrompt: "Haben Sie Vorschläge/Feedback für das Team? (optional)",
    feedbackPlaceholder: "Kommentare",
  },
  Spanish: {
    title: "Conectividad de la red de oficina",
    question: "Seleccione una o más de las siguientes opciones para las que le gustaría proporcionar una calificación:",
    options: [
      "Rendimiento de las conexiones por cable",
      "Rendimiento de las conexiones inalámbricas",
      "Comentarios sobre el uso de VPN",
      "Propuestas de mejoras",
    ],
    feedbackPrompt: "¿Tiene alguna sugerencia/comentario para el equipo? (opcional)",
    feedbackPlaceholder: "Comentarios",
  },
  French: {
    title: "Connectivité réseau de bureau",
    question: "Veuillez sélectionner une ou plusieurs des options suivantes pour lesquelles vous souhaitez fournir une évaluation :",
    options: [
      "Performance des connexions filaires",
      "Performance des connexions sans fil",
      "Commentaires sur l'utilisation du VPN",
      "Propositions d'améliorations",
    ],
    feedbackPrompt: "Avez-vous des suggestions/commentaires pour l'équipe ? (optionnel)",
    feedbackPlaceholder: "Commentaires",
  },
};

const OfficeNetworkComponent = () => {
  const dispatch = useDispatch();
  const selectedLanguage = useSelector((state) => state.language.selectedLanguage);
  const translation = translations[selectedLanguage];

  const selectedOptions = useSelector((state) => state.officeNetwork.selectedOptions) || [];
  const isOptionSelected = useSelector((state) => state.officeNetwork.isOptionSelected);
  const comments = useSelector((state) => state.officeNetwork.comments);

  const handleOptionChange = (checkedValues) => {
    dispatch(setSelectedOptions(checkedValues));

    dispatch(
      setOfficeNetworkFeedback(
        "Office network connectivity",
         translations['English'].question,
         checkedValues,
         translations['English'].feedbackPrompt,
         comments,
      )
    );
  };

  const handleCommentsChange = (e) => {
    const value = e.target.value;

    dispatch(setOfficeNetworkComments(value));

    dispatch(
      setOfficeNetworkFeedback(
        "Office network connectivity",
         translations['English'].question,
         selectedOptions,
         translations['English'].feedbackPrompt,
         value,
      )
    );
  };

  return (
    <div>
      <h3 style={{ paddingLeft: "15px",marginTop:"20px" }}>{translation.title}</h3>
      <div style={{ padding: "15px" }}>
        <h2>{translation.question}</h2>
        <Checkbox.Group
          options={translation.options}
          onChange={handleOptionChange}
          value={selectedOptions}
          style={{ display: "flex", flexDirection: "row", gap: "10px" }}
          className="custom-checkbox-group"
        />
        {isOptionSelected && (
          <div style={{ padding: "3%" }}>
            <p>{translation.feedbackPrompt}</p>
            <Input.TextArea
              value={comments}
              onChange={handleCommentsChange}
              placeholder={translation.feedbackPlaceholder}
              style={{ width: "96%" }}
            />
          </div>
        )}
      </div>
    </div>
  );
};

export default OfficeNetworkComponent;